import Link from "@mui/material/Link";
import type React from "react";

export interface LinkButtonProps {
  children?: React.ReactNode;
  ref?: React.Ref<any>;
  [key: string]: any;
}

export const LinkButton = ({ children, ref, ...props }: LinkButtonProps) => (
  <Link
    ref={ref}
    color="secondary"
    component="button"
    underline="always"
    {...props}
  >
    {children}
  </Link>
);
